var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wave__container",class:_vm.work && 'wave__container--work'},[_vm._l((54),function(w){return _c('div',{key:w + 'wave',staticClass:"wave__bar",class:_vm.sound && 'wave__bar--sound'})}),(_vm.work)?_c('div',{staticClass:"wave__duration"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }